import React from 'react';
import { motion } from 'framer-motion';
import { FiMessageCircle, FiPhoneCall, FiMail } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const HelpCenter = () => {
  return (
    <section className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12 sm:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-8 sm:mb-12"
        >
          <h1 className="text-3xl sm:text-4xl font-bold text-blue-700 mb-4">
            24/7 Help Center
          </h1>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
            Need assistance? Our NRI Local Buddy support team is available around the clock.  
            Reach us via live chat, call, or email — we’re here to help anytime.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mt-8 sm:mt-12">
          {/* Chat Support */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white shadow-lg rounded-2xl p-8 text-center border border-gray-100"
          >
            <div className="flex justify-center mb-4 text-blue-600 text-5xl">
              <FiMessageCircle />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-800">
              Live Chat Support
            </h3>
            <p className="text-gray-600 mb-4">
              Connect instantly with our support agents for quick assistance.
            </p>
            <Link
              to="/chat"
              className="inline-block px-6 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition"
            >
              Start Chat
            </Link>
          </motion.div>

          {/* Call Support */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white shadow-lg rounded-2xl p-8 text-center border border-gray-100"
          >
            <div className="flex justify-center mb-4 text-green-600 text-5xl">
              <FiPhoneCall />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-800">
              Call Support
            </h3>
            <p className="text-gray-600 mb-4">
              Prefer to talk? Our team is just a call away, anytime you need us.
            </p>
            <a
              href="https://wa.me/919618222498"
              className="inline-block px-6 py-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition"
            >
              Call Now
            </a>
          </motion.div>

          {/* Email Support */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white shadow-lg rounded-2xl p-8 text-center border border-gray-100"
          >
            <div className="flex justify-center mb-4 text-red-600 text-5xl">
              <FiMail />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-800">
              Email Support
            </h3>
            <p className="text-gray-600 mb-4">
              Send us your queries or issues and we’ll respond promptly.
            </p>
            <a
              href="mailto:hello@ay-technologies.com"
              className="inline-block px-6 py-2 bg-red-600 text-white rounded-full hover:bg-red-700 transition"
            >
              Email Us
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="text-center mt-16"
        >
          <p className="text-gray-700">
            Our NRI Local Buddy support operates <strong>24/7</strong> —  
            ensuring you always have help no matter where you are in the world.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default HelpCenter;
